import React, { useState, useEffect } from 'react';
import { FaCheck, FaSearchPlus, FaCartPlus, FaChevronLeft, FaChevronRight } from 'react-icons/fa';


const ProductDetailModal = ({ product, isOpen, onClose, onAddToCart }) => {
  const [quantity, setQuantity] = useState(1);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [added, setAdded] = useState(false);

  // Cierre con botón físico atrás (Android / Navegador)
useEffect(() => {
  if (!isOpen) return;
  window.history.pushState({ modal: true }, '');

  const handlePopState = () => {
    onClose();
  };
  window.addEventListener('popstate', handlePopState);

  return () => {
    window.removeEventListener('popstate', handlePopState);
    // Si cierras el modal, regresa el historial si fue abierto así
    if (window.history.state && window.history.state.modal) {
      window.history.back();
    }
  };
}, [isOpen, onClose]);

  if (!isOpen || !product) return null;
console.log("PRODUCTO QUE LLEGA AL MODAL:", product);
  const handleAddToCart = () => {
    onAddToCart(product, quantity);
    setAdded(true);
    setTimeout(() => setAdded(false), 1200); // feedback corto
    setTimeout(onClose, 1000); // cierra modal un poco después
  };

  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <svg
          key={i}
          className={`w-5 h-5 ${i <= rating ? 'text-yellowStar' : 'text-gray-300'}`}
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.538 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.783.57-1.838-.197-1.538-1.118l1.07-3.292a1 1 0 00-.364-1.118l-2.8-2.034c-.783-.57-.38-1.81.588-1.81h3.462a1 1 0 00.95-.69l1.07-3.292z"></path>
        </svg>
      );
    }
    return stars;
  };

  const images = product.images?.length ? product.images : [product.image];

  const nextImage = () => setCurrentImageIndex((prev) => (prev + 1) % images.length);
  const prevImage = () => setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);

  return (
<div className="fixed inset-0 bg-black bg-opacity-90 backdrop-blur-sm flex justify-center items-center z-[100] p-2 sm:p-4 animate-modalIn">
<div className="bg-[#161e2e] bg-opacity-95 text-blue-400 rounded-2xl shadow-2xl p-4 sm:p-8 w-full max-w-lg sm:max-w-3xl relative transform scale-100 transition-all duration-300">
        {/* Botón cerrar */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-primary bg-white/80 hover:bg-background p-3 rounded-full shadow-md text-2xl"
        >
          &times;
        </button>

        {/* Slider de imágenes */}
        <div className="flex flex-col sm:flex-row gap-4 sm:gap-8">
          <div className="w-full sm:w-1/2 relative flex flex-col items-center">
            <img
              src={images[currentImageIndex]}
              alt={product.name}
              className="w-full h-56 object-cover rounded-xl shadow-lg border border-waterBlue/30"
            />
            {images.length > 1 && (
              <>
<button
  onClick={prevImage}
  className="absolute top-1/2 left-2 -translate-y-1/2 bg-white/80 hover:bg-primary text-primary hover:text-white p-2 rounded-full shadow transition-all"
>
  <FaChevronLeft className="w-4 h-4" />
</button>
<button
  onClick={nextImage}
  className="absolute top-1/2 right-2 -translate-y-1/2 bg-white/80 hover:bg-primary text-primary hover:text-white p-2 rounded-full shadow transition-all"
>
  <FaChevronRight className="w-4 h-4" />
</button>
                <div className="absolute bottom-2 left-0 right-0 flex justify-center gap-2">
                  {images.map((_, idx) => (
                    <span key={idx} className={`block w-2 h-2 rounded-full ${currentImageIndex === idx ? 'bg-primary' : 'bg-gray-300'}`} />
                  ))}
                </div>
              </>
            )}
          </div>
          {/* Info producto */}
          <div className="w-full sm:w-1/2 flex flex-col justify-between">
<h2 className="text-2xl sm:text-3xl font-bold text-blue-200 mb-2">{product.name}</h2>
            <div className="flex items-center mb-2">{renderStars(product.rating)}
              <span className="text-xs text-gray-400 ml-2">({product.reviews} reseñas)</span>
            </div>
<p className="text-blue-100 text-3xl font-extrabold mb-3">
  {Number(product.price).toLocaleString("es-CO", { style: "currency", currency: "COP", minimumFractionDigits: 0 })}
</p>
<p className="text-blue-300 text-base leading-relaxed mb-5">{product.description}</p>
            {/* Cantidad */}
            <div className="flex items-center mb-4">
<span className="text-lg font-semibold text-blue-200 mr-4">Cantidad:</span>
              <button
                onClick={() => setQuantity(Math.max(1, quantity - 1))}
                className="bg-gray-200 text-textPrimary px-3 py-1 rounded-md hover:bg-gray-300 text-xl font-bold"
              >-</button>
              <span className="mx-4 text-lg">{quantity}</span>
              <button
                onClick={() => setQuantity(quantity + 1)}
                className="bg-gray-200 text-textPrimary px-3 py-1 rounded-md hover:bg-gray-300 text-xl font-bold"
              >+</button>
            </div>
            {/* Botón agregar */}
            <button
              onClick={handleAddToCart}
              disabled={added}
className={`w-full py-3 rounded-xl font-bold text-lg shadow-lg transition-all
  ${added ? "bg-green-500 text-white scale-95" : "bg-blue-600 text-white hover:bg-blue-700 active:scale-95"}`}
            >
              {added ? (
                <span className="flex items-center justify-center gap-2">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                  ¡Agregado!
                </span>
              ) : (
                "Agregar al Carrito"
              )}
            </button>
          </div>
        </div>
      </div>
      {/* Animación modal */}
      <style>{`
        @keyframes modalIn {
          from { opacity: 0; transform: scale(0.97);}
          to { opacity: 1; transform: scale(1);}
        }
        .animate-modalIn {
          animation: modalIn 0.3s cubic-bezier(.4,0,.2,1) both;
        }
      `}</style>
    </div>
  );
};

export default ProductDetailModal;
